import React, { useCallback } from 'react';
import { Box, Stack } from '@mui/material';
import SkillsView from './Show/SkillsView';
import { useFieldHelper } from 'framework/ui/field';
import { SkillsInputsConfig } from './types';
import { Alert } from 'framework/ui/mui-builder';
import CareerSectionTitle from '../CareerCapabilities/shared/CareerSectionTitle';
import EditSkillsButtonWithModal from './shared/buttons/EditSkillsButtonWithModal';

const EmployeeSkillsContent = () => {
  const { getValue } = useFieldHelper<SkillsInputsConfig>({ source: 'skillsShema' });
  const skillsShema = getValue();

  const renderActionButtons = useCallback(() => {
    return <EditSkillsButtonWithModal />;
  }, []);

  const renderSkillsContent = () => {
    if (!Array.isArray(skillsShema?.skills) || skillsShema.skills.length === 0) {
      return <Alert color="info">Skills not found</Alert>;
    }

    return <SkillsView />;
  };

  return (
    <Box position="relative">
      <Stack gap={1.5}>
        <CareerSectionTitle title="Skills">{renderActionButtons()}</CareerSectionTitle>
        <Box>{renderSkillsContent()}</Box>
      </Stack>
    </Box>
  );
};

export default EmployeeSkillsContent;
